import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { RegistrationService } from '../services/registration.service';

@Component({
  selector: 'app-forgot-username',
  templateUrl: './forgot-username.component.html',
  styleUrls: ['./forgot-username.component.scss'],
})
export class ForgotUsernameComponent implements OnInit {
  forgotUsernameForm: FormGroup;
  submitText = 'Submit';
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private registrationService: RegistrationService,
  ) {}

  ngOnInit(): void {
    this.forgotUsernameForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  get f() {
    return this.forgotUsernameForm.controls;
  }

  onSubmit() {
    if (this.forgotUsernameForm.invalid) return;
    this.submitText = 'Please Wait ...';
    const { email } = this.forgotUsernameForm.value;
    this.registrationService.forgotUsername(email).subscribe(
      (response) => {
        Swal.fire({
          icon: 'success',
          text: response?.message || 'If the email address is registered, the username has been sent to it.',
          showConfirmButton: true,
          confirmButtonText: 'Ok',
        }).then(() => {
          this.router.navigate(['/login']);
        });
      },
      (error) => {
        console.error(error);
        this.submitText = 'Submit';
        Swal.fire({
          icon: 'error',
          text: error.error?.message || 'Request failed. Please try again.',
          showConfirmButton: true,
          confirmButtonText: 'Ok',
        });
      },
    );
  }
}
